import React from "react";
import "./ecommerceAlwaysEfficient.scss";

//Imagens:
import ImgEcommerceAlwaysEfficient from "../../../../assets/ecommerce/ecommerce.png";
import { useTranslation } from "react-i18next";

function EcommerceAlwaysEfficient() {

  const { t } = useTranslation()

  return (
    <div className="container-ecommerce-always-efficient">
      <div className="img-ecommerce-always-efficient">
        <img src={ImgEcommerceAlwaysEfficient} alt="" />
      </div>
      <div className="texts-ecommerce-always-efficient">
        <h1>{t("ecommerce.title")}</h1>
        <p>{t("ecommerce.section_text_1")}</p>
        <p>{t("ecommerce.section_text_2")}</p>
        <p>{t("ecommerce.section_text_3")}</p>
        <a href="/form">
          <button id="btn-ecommerce-always-efficient">
            {t("buttons.demo_btn_alternative_text_1")}
          </button>
        </a>
      </div>
    </div>
  );
}

export default EcommerceAlwaysEfficient;
